module.exports = __webpack_public_path__ + "img/user_empty.689d2c2f.png";